import { format } from "date-fns";

export const dateFormat = (prop) => {
  return format(new Date(prop), "dd.MM.yyyy");
};
export const dateFormatUTC = (prop) => {
  return format(new Date(prop), "yyyy-MM-dd") + "T00:00:00.000Z";
};
